import { render, staticRenderFns } from "./flash-confetti.vue?vue&type=template&id=d52f8fb4&"
import script from "./flash-confetti.vue?vue&type=script&lang=js&"
export * from "./flash-confetti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports